import ConfigService from './services/config/config.service';
import { IsProduction } from "./util/Environment";

function sleep(seconds: number): Promise<void> {
    return new Promise(res => setTimeout(res, seconds * 1000));
}

export async function LoadStaticScripts(history: any) {
    await sleep(4);

    if (IsProduction()) {
        const ReactGA = await import("react-ga");
        const Hotjar = (await import("react-hotjar")).hotjar;

        const config = ConfigService.getConfig().miscellaneousConfig;

        ReactGA.initialize(config.gATracking);
        Hotjar.initialize({
            id: Number(config.hotjarId),
            sv: Number(config.hotjarSV)
        });

        history.listen((location, action) => {
            ReactGA.set({ page: location.pathname });
            ReactGA.pageview(location.pathname);
            window.scrollTo(0, 0);
        });
    }
}
